module.exports = __webpack_public_path__ + "img/img16.ed547d0f.svg";